/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Editemail1Inputs */

const en_form_editemail1 = /** @type {(inputs: Form_Editemail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit email`)
};

/**
* | output |
* | --- |
* | "Edit email" |
*
* @param {Form_Editemail1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const form_editemail1 = /** @type {((inputs?: Form_Editemail1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Editemail1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_form_editemail1(inputs)
});
export { form_editemail1 as "form_editEmail" }